import type { PropsWithChildren } from 'react';
import './Body.scss';

export type BodyProps = PropsWithChildren<{
  backgroundColor?: string;
}>;

export function Body({ children }: BodyProps) {
  return (
    <div className="body__container">
      <div className="body__content">{children}</div>
    </div>
  );
}
